import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../auth/services/auth/auth.service';

@Component({
  selector: 'baf-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.verify();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts